import React, { useEffect, useState } from 'react'
import { db } from '../firebase';
import Cardplato from './Cardplato';
import { collection, getDocs } from "firebase/firestore";

var  getLinks="";

/*export const use=getLinks()*/

export function cambiar(tabla){
  getLinks(tabla)
}

const Containerplatos= (props) =>{


  const [links, setLinks] = useState([]);


  getLinks = async (tabla) => {
    const querySnapshot = await getDocs(collection(db, tabla));
    const docs = [];
    querySnapshot.forEach((doc) => {
      docs.push({ ...doc.data(), id: doc.id })
    });

    setLinks(docs);
  };

  

  useEffect(() => {
    getLinks(props.tabla)
  }, [])

  return (
    <section className="content" id="contentID">

      {links.map(link => {
        return <Cardplato key={link.nombre} nombre={link.nombre} descripcion={link.descripcion} precioR={link.precioR} precioL={link.precioL} precioD={link.precioD} imagen={link.imagen} />
      })}

    </section>
  )
}



export default Containerplatos
